<template>
  <DsfFormControlBox class="ds-textbox" :owner="_self" :class="{'ds-textbox__has-prefix':!readOnly&&valuePrefix,'ds-textbox-append-block__none':append&&!isAppendGroup&&!isAppendBackgroundColor}">
    <template v-slot:simple>
      <DsfTextProxy v-model="value" v-bind="_self.$props"></DsfTextProxy>
      <span v-if="value != ''">{{ append }}</span>
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
    <template v-slot:content>
      <template v-if="!readOnly">
        <template v-if="inputMode!='step'">
          <div 
            class="el-input"
            :class="{
              'ds-error-border':errors.length>0,
              'is-disabled':disabled,
              'el-input-group':isPrefixGroup||isAppendGroup||append||valuePrefix,
              'el-input-group--prepend':isPrefixGroup,
              'el-input-group--append':isAppendGroup||append,
              'el-input--suffix':isSuffix,
              'el-input--prefix':isPrefix
            }"
          >
            <div class="ds-textbox-value-prefix" v-if="valuePrefix">{{valuePrefix}}</div>
            <div class="el-input-group__prepend" v-if="isPrefixGroup">
              <slot name="prepend"></slot>
            </div>
            <input :type="inputType" v-model="bindInputValue" :disabled="disabled" autocomplete="off" :placeholder="$t(placeholder)" class="el-input__inner" @change="inputChangeHandler" @focus="inputFocusHandler" @blur="inputBlurHandler" @keyup="keyupHandler($event)" />
            <span class="el-input__prefix" v-if="isPrefix">
              <slot name="prefix"></slot>
            </span>
            <span class="el-input__suffix" v-if="isSuffix">
              <span class="el-input__suffix-inner">
                <slot name="suffix"></slot>
              </span>
            </span>
            <div class="el-input-group__append" v-if="isAppendGroup||append">
              <slot name="append">
                {{ $t(append) }}
              </slot>
            </div>
          </div>
        </template>
        <template v-else>
          <StepTextBox v-model="bindInputValue" @focus="inputFocusHandler" @blur="inputBlurHandler" :disabled="disabled" :setp-template="setpTemplate" :setp-input-temp="setpInputTemp">
          </StepTextBox>
        </template>
      </template>
      <!--只读状态只显示div-->
      <div v-else class="ds-form-readonly">
        <DsfTextProxy v-model="value" v-bind="_self.$props" :show-label="false"></DsfTextProxy>
        <span v-if="value != ''">{{ $t(append) }}</span>
      </div>
      <slot name="error">
        <div v-if="errors.length>0" class="ds-error-text">{{ errorsMsg }}</div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>
<script>
import textFilterRule from "./textFilterRule";
import StepTextBox from "./stepTextBox.vue";
export default dsf.component({
  name: "DsfTextbox",
  mixins: [$mixins.formControl, textFilterRule],
  ctrlCaption: "文本框",
  components: {
    StepTextBox: StepTextBox
  },
  props: {
    lazyModel: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },
    ishideCon: {
      type: Boolean,
      default: false
    },
    openInputGrade: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请输入"
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("text-meta-data");
      }
    },
    append: {
      type: String,
      default: ""
    },
    isAppendBackgroundColor: {
      type: Boolean,
      default: true
    },
    //只允许数字键
    onlyAllowNumberKey: {
      type: Boolean,
      default: false
    },
    emptyPlaceholder: {
      type: String,
      default: ""
    },
    valuePrefix: {
      type: String,
      default: ""
    },
    inputMode: {
      type: String,
      default: "normal" // text step
    },
    setpTemplate: {
      type: String,
      default: "xxxx-xxxx"
    },
    setpInputTemp: {
      type: String,
      default: "x"
    }
  },
  data() {
    return {
      bindInputValue: "",
      //允许接受回车聚焦
      allowEnterFocus: true
    };
  },
  computed: {
    inputType() {
      return this.ishideCon ? "password" : "text";
    }
  },
  created() {
    let _this = this;
    Object.defineProperty(this, "isPrefixGroup", {
      get() {
        return _this.$slots.prepend;
      }
    });
    Object.defineProperty(this, "isAppendGroup", {
      get() {
        return _this.$slots.append;
      }
    });
    Object.defineProperty(this, "isPrefix", {
      get() {
        return _this.$slots.prefix;
      }
    });
    Object.defineProperty(this, "isSuffix", {
      get() {
        return _this.$slots.suffix;
      }
    });
  },
  mounted() {
    // if (this.$slots.prepend) {
    //   this.isPrefixGroup = true;
    // }
    // if (this.$slots.append) {
    //   this.isAppendGroup = true;
    // }
    // if (this.$slots.prefix) {
    //   this.isPrefix = true;
    // }
    // if (this.$slots.suffix) {
    //   this.isSuffix = true;
    // }
  },
  methods: {
    $emitValueChange(v) {
      if (this.inputMode == "normal") {
        if (v && this.valuePrefix) {
          v = this.valuePrefix + v;
        } else if (this.valuePrefix && !v) {
          v = "";
        }
      }
      $mixins.formControl.methods.$emitValueChange.call(this, v);
    },
    focus() {
      this.inClient = true;
      this.$nextTick(() => {
        $(this.$el).find("input:visabled").get(0).focus();
      });
    },
    keyupHandler(evt) {
      if (this.onlyAllowNumberKey) {
        var value = this.bindInputValue.replace(/[^\d\.]/g, "");
        // this.inputValue = value;
        this.$dispatch("keyup", value);
      }
    },
    inputChangeHandler() {
      let value = this.filterFormat(this.bindInputValue);
      // this.inputValue = value;
      if (this.lazyModel) {
        this.$emitValueChange(value);
      }
      this.$nextTick(() => {
        this.emitFormValidate(value);
        this.$dispatch("change", value);
      });
    },
    inputBlurHandler() {
      this.$dispatch("blur");
    },
    inputFocusHandler() {
      this.$dispatch("focus");
    }
  },
  watch: {
    value: {
      handler(v, ov) {
        if (this.inputMode == "normal") {
          if (this.valuePrefix && v) {
            v = v?.toString().replace(this.valuePrefix, "");
          }
        }
        this.bindInputValue = v;
      },
      immediate: true
    },
    bindInputValue(v) {
      if (!this.lazyModel) {
        this.$emitValueChange(v);
      }
    }
  }
  // destroyed(){
  //   console.log("text-box-destroyed")
  // },
  // updated(){
  //   console.log('textbox-updated')
  // }
});
</script>
